import { z } from 'zod';
export const SharpFitSchema = z.enum(['cover', 'contain', 'fill', 'inside', 'outside']);
